
export class Stiuacao{
    Codigo:number;
    Descricao:string;
}